export interface IAuditActor {
  id: string | null;
  type: string | null;
  email: string | null;
  name: string | null;
}

export interface ISubscriptionAuditEvent {
  id: string;
  type: string | null;
  description: string | null;
  dateOccurred: string;
  performedBy: IAuditActor | null;
  correlationId: string | null;
}

export enum AUDIT_EVENT_FIELDS {
  ID = 'id',
  TYPE = 'type',
  DESCRIPTION = 'description',
  DATE_OCCURRED = 'dateOccurred',
  PERFORMED_BY = 'performedBy',
  CORRELATION_ID = 'correlationId',
}

// EMS (Entitlement Management Service) audit event types

export interface IEmsAuditActorResponse {
  id: string | null;
  type: string | null;
  name: string | null;
  parentActor: IEmsAuditActorResponse | null;
}

export interface IEmsClaimSnapshot {
  brand: string | null;
  code: string | null;
  isActive: boolean;
  validFrom: string | null;
  validTo: string | null;
}

export interface IEmsEntitlementSnapshot {
  process: string | null;
  system: string | null;
  sourceId: string | null;
  importedBy: string | null;
  claims: IEmsClaimSnapshot[] | null;
  modificationTimestamp: string;
  roles: string[] | null;
}

export interface IEmsAuditEventBase {
  id: string;
  type: string;
  description: string | null;
  dateOccurred: string;
  performedBy: IEmsAuditActorResponse | null;
  correlationId: string | null;
}

export interface IEntitlementUpsertedAuditEvent extends IEmsAuditEventBase {
  type: 'auditing.event.entitlement.upserted.v1';
  oldEntitlement: IEmsEntitlementSnapshot | null;
  newEntitlement: IEmsEntitlementSnapshot | null;
}

export interface IEntitlementDeletedAuditEvent extends IEmsAuditEventBase {
  type: 'auditing.event.entitlement.deleted.v1';
  deletedEntitlement: IEmsEntitlementSnapshot | null;
}

export type IEmsAuditEvent = IEntitlementUpsertedAuditEvent | IEntitlementDeletedAuditEvent;
